export const DEFAULT_COUNTRY_COORDINATES = { lat: 38, lng: -94 }
export const DEFAULT_MAP_ZOOM = 3
export const METERS_IN_MILE = 1609.34
export const METERS_IN_KM = 1000
